import { defineComponent as n } from "vue";
const d = n({
  name: "CsTabs",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: [String],
    options: {
      default: () => [],
      type: Array
    }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    function a(e) {
      t("update:modelValue", e);
    }
    function l(e) {
      return e === o.modelValue;
    }
    return {
      onClick: a,
      isChecked: l
    };
  }
});
export {
  d as default
};
